import { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

import { ToastService, useDataTableBasic } from '@iamsoftware/react-hooks';

import { AgreementTemplateService as Service } from './AgreementTemplateService';

export const FormFields = ({ display, setDisplay }) => {

  const [formFieldTypes, setFormFieldTypes] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  useEffect(() => {
    Service.getFormFieldTypes().then(data => {
      setFormFieldTypes(data.listData.map(item => {
        return { value: item.enumId, label: item.description };
      }));
    });
  }, []);

  const downloadTemplate = (type: string) => () => {
    window.open(`${Service.baseURL}/iam-main/template-agreements/${display?.agreementId}/download-${type}`);
  }
  const header = (
    <div className='flex align-items-center justify-content-between'>
      <div>
        Trường thông tin - {display?.agreementName || display?.agreementId}
      </div>
    </div>
  );
  const footer = (
    <div className="flex justify-content-between align-items-center">

      <div className={'mt-2'}>
        <Button label="Lưu" icon="pi pi-check" className="p-button-sm" type="button" onClick={() => setSubmitting(true)} loading={submitting} />
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplay(false)} />
      </div>
    </div>
  );

  return (
    <Dialog header={header} footer={footer} visible={!!display} style={{ width: '100rem' }} position="top" onHide={() => setDisplay(false)}>
      <Screen formFieldTypes={formFieldTypes} agreementId={display?.agreementId} setDisplay={setDisplay} submitting={submitting} setSubmitting={setSubmitting} />
    </Dialog>
  );
}

const Screen = ({ formFieldTypes, agreementId, submitting, setSubmitting, setDisplay }) => {

  const dataKey = 'fieldName';

  const [items, setItems] = useState([]);
  const [orderItemFields, setOrderItemFields] = useState([]);

  useEffect(() => {
    if (agreementId) {
      load();
    }
  }, [agreementId]); // eslint-disable-line react-hooks/exhaustive-deps

  const load = () => {
    Service.getOrderItemPrototypeFields().then(data => {
      setOrderItemFields(data.items.map(item => {
        return { value: item.fieldName, label: item.title };
      }));
    });
    Service.getFormFields(agreementId).then(data => {
      setItems(data.dbFormFields.map(field => {
        field.isRequired = field.isRequired === 'Y';
        return field;
      }));
    });
  }
  const onEditorChange = (rowData, column, newValue) => {
    setItems(prevItems => prevItems.map(prevItem => {
      if (prevItem[dataKey] === rowData[dataKey]) {
        return {
          ...prevItem,
          [column.field]: newValue
        }
      }
      return prevItem;
    }));
  }

  const { render: renderDataTableItem } = useDataTableBasic({
    tableHeader: `Danh sách trường thông tin`,
    dataKey,
    indexColumnWidth: 45,
    columns: [
      {
        field: 'fieldName', header: 'Tên trường', width: 250,
        sortable: true
      },
      // {
      //   field: 'tooltip', header: 'Mô tả', width: 200,
      //   sortable: true,
      //   dataType: 'editor', editorConfig: {
      //     onEditorChange,
      //     field: {type: 'text'}
      //   }
      // },
      {
        field: 'isRequired',
        header: () => (
          <div className="flex align-items-center justify-content-center">
            <Checkbox
              onChange={(e) => {
                const checked = e.checked;
                setItems(prev => prev.map(item => ({ ...item, isRequired: checked })));
              }}
              checked={items.length > 0 && items.every(item => item.isRequired)}
            />
            <span className="ml-2">Bắt buộc</span>
          </div>
        ),
        minWidth: 250,
        sortable: true,
        headerStyle: { whiteSpace: 'nowrap' },
        dataType: 'editor', editorConfig: {
          onEditorChange,
          field: { type: 'Checkbox' }
        }, className: 'text-center'
      },
      {
        field: 'fieldTypeEnumId', header: 'Kiểu dữ liệu', width: 250,
        sortable: true,
        dataType: 'editor', editorConfig: {
          onEditorChange,
          field: { type: 'Dropdown', DropdownProps: { options: formFieldTypes, showClear: true, style: { width: '100%' } } }
        }
      },
    ],
    items
  });

  useEffect(() => {
    if (submitting) {
      const dbFormFields = items.map(item => {
        item.isRequired = item.isRequired ? 'Y' : 'N';
        return item;
      })
      Service.setFormFields(agreementId, dbFormFields).then(() => {
        ToastService.success();
        load();
      }).catch(() => {
      }).finally(() => {
        setSubmitting(false);
        setDisplay(false)
      });
    }
  }, [submitting]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="grid">
      <div className="col-12 p-fluid">
        {renderDataTableItem()}
      </div>
    </div>
  );
}